import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function PresentationSection() {
  return <section className="pt-6 pb-1 bg-[#FFFFFF]" data-id="element-99">
      <div className="container mx-auto px-4" data-id="element-100">
        <div className="max-w-2xl mx-auto text-center" data-id="element-101">
          <FadeIn delay={0.1} data-id="element-102"></FadeIn>

          <FadeIn delay={0.15} data-id="element-103">
            <p className="text-base md:text-lg leading-relaxed mb-2" style={{
            color: 'var(--color-body)'
          }} data-id="element-104">
              <strong style={{
              color: 'var(--color-deep-blue)'
            }} data-id="element-105">
                Pequeños Amigos de Dios
              </strong>{' '}
              es una biblioteca amplia y muy valiosa cuyo corazón son{' '}
              <strong data-id="element-106">
                500 parábolas para niños con enseñanzas y preguntas
              </strong>
              . Un recurso pensado para acompañar a los más pequeños en
              distintos momentos de su crecimiento espiritual, con historias
              organizadas por temáticas que ayudan a reflexionar, conversar y
              aprender con profundidad.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-107"></FadeIn>
        </div>
      </div>
    </section>;
}